import cx from 'classnames';
import { CircleTickSvg } from './assets';
import { ErrorAlert } from 'core/components';
import { useFileDownloader } from './hooks';
import styles from './styles.scss';
/* eslint-disable react/prop-types */ // TODO: add props

const UploadedFile = ({ fileName, blockId, activityResponseId }) => {
  const { downloadUrl, downloadFileUrl, handleDownloadedUrl, downloadError } =
    useFileDownloader();

  const handleDownload = async () => {
    await downloadFileUrl(blockId, activityResponseId);

    if (downloadUrl) {
      handleDownloadedUrl(downloadUrl, fileName);
    }
  };

  if (downloadError) {
    return <ErrorAlert statusCode={downloadError.status} />;
  }

  return (
    <div className={cx(styles.container, styles.space)}>
      <CircleTickSvg />
      <p className={styles.highlighted}>Your file has been uploaded.</p>
      <button className={styles.linkedButton} onClick={handleDownload}>
        {fileName}
      </button>
    </div>
  );
};

export default UploadedFile;
